import { hasValue } from "../../../utils/functions.js";
import SummaryCard from "../../sub-components/Generic/SummaryCard.vue";

export default {
  name: "BankAccount",
  components: {
    SummaryCard
  },
  data() {
    return {
      listBankAccounts: [],
      bankAccounts: [],
      accountTypes: [],
      summaryData:{
        PreviousBalance: null,
        ReceivableAccountAmount: null,
        PayableAccountAmount: null,
        BalancePreview: null,
        ReceivableAccountAmountUnconciliated: null,
        PayableAccountAmountUnconciliated: null,
        BalancePreviewWithUnconciliated: null,
        QtUnconciliatedBankStatementDetails: null,
        QtUnconciliatedAccountsReceivable: null,
        QtUnconciliatedAccountsPayable: null
      },

      filter: this.FilterDefault(),
      infoField: this.InfoFieldDefault(),
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },

      countFilter: 0,
      idField: 0,
      isSeeing: false,

      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingSummary: false,

      modalTitle: "Nova Categoria",
      pOpened: null,
      validatedFieldForm: false
    };
  },
  mounted() {
    this.ListBankAccount();
    this.GetBanksAndAccountTypes();
    this.GetSummary();
  },
  computed:{
    summary() {
      return {
        DayPreview:{
          items: [
            {
              label: 'Saldo Anterior:', style: "color: #000080",  icon: 'fas fa-arrow-left',
              amount: this.summaryData.PreviousBalance
            },
            {
              label: '+Contas a Receber:', style: "color: green",  icon: 'fas fa-arrow-up',
              amount: this.summaryData.ReceivableAccountAmount
            },
            {
              label: '-Contas a Pagar:', style: "color: red",  icon: 'fas fa-arrow-down',
              amount: this.summaryData.PayableAccountAmount
            },
          ],
          total: {
            label: 'Saldo Previsto:', style: "color: " + this.DefineColor(this.summaryData.BalancePreview), icon: 'fas fa-exchange-alt',
            amount: this.RemoveNegative(this.summaryData.BalancePreview), 
          }
        },
        DayPreviewWithDelay:{
          items: [
            {
              label: 'Saldo Previsto:', style: "color: #000080",  icon: 'fas fa-exchange-alt',
              amount: this.summaryData.BalancePreview > 0 ? this.summaryData.BalancePreview : (this.summaryData.BalancePreview * -1), 
            },
            {
              label: '+Contas a Receber Atrasado:', style: "color: green",  icon: 'fas fa-arrow-up',
              amount: this.summaryData.ReceivableAccountAmountUnconciliated
            },
            {
              label: '-Contas a Pagar Atrasado:', style: "color: red",  icon: 'fas fa-arrow-down',
              amount: this.summaryData.PayableAccountAmountUnconciliated
            },
          ],
          total: {
            label: 'Saldo Previsto com Atrasados:', style: "color: " + this.DefineColor(this.summaryData.BalancePreviewWithUnconciliated),  icon: 'fas fa-exchange-alt',
            amount: this.RemoveNegative(this.summaryData.BalancePreviewWithUnconciliated)
          }
        },
        PendingConciliations:{
          items: [
            {
              label: 'Contas(s) Correntes:', style: "color: #000080",  icon: 'fas fa-exchange-alt',
              releaseQtd: this.summaryData.QtUnconciliatedBankStatementDetails
            },
            {
              label: '+Contas a Receber:', style: "color: green",  icon: 'fas fa-arrow-up',
              releaseQtd: this.summaryData.QtUnconciliatedAccountsReceivable
            },
            {
              label: '-Contas a Pagar:', style: "color: red",  icon: 'fas fa-arrow-down',
              releaseQtd: this.summaryData.QtUnconciliatedAccountsPayable
            },
          ],
        },
      }
    }
  },
  methods: {
    DefineColor(value){
      return value < 0 ? "red" : (value == 0 ? "#000080" : "green");
    },
    RemoveNegative(value){
      return value > 0 ? value : (value * -1)
    },
    OpenField(e, i, view) {
      e.preventDefault();
      this.validatedFieldForm = false;
      this.ResetInfoField();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idField = this.listBankAccounts[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Conta Bancária";
        this.GetBankAccount();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Conta Bancária";
        this.ResetInfoField();
      } else {
        // View
        this.pOpened = i;
        this.idField = this.listBankAccounts[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da Conta Bancária";
        this.GetBankAccount();
      }
      this.$bvModal.show("mFormField");
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListBankAccount();
    },
    ResetFilter() {
      this.filter = this.FilterDefault();
      this.ListBankAccount();
    },
    ResetInfoField() {
      this.infoField = this.InfoFieldDefault();
    },
    FilterDefault() {
      return {
        Bank: { Code: null },
        AccountType: { Code: null },
        BankAgency: null,
        BankAgencyDigit: null,
        BankAccount: null,
        BankAccountDigit: null,
        IsExcluded: false
      };
    },
    InfoFieldDefault() {
      return {
        Bank: { Code: null },
        AccountType: { Code: null },
        BankAgency: null,
        BankAgencyDigit: null,
        BankAccount: null,
        BankAccountDigit: null
      };
    },
    GoToAccountBalance(e, i) {
      e.preventDefault();
      let idAccount = this.listBankAccounts[i].Code;
      this.$router.push({
        name: "bank-statement",
        params: { idAccount: idAccount }
      });
    },
    GoToConciliation(bankAccount = null) {
      if(bankAccount == null && this.summaryData.QtUnconciliatedBankStatementDetails <= 0){
        this.$makeToast("Não existem lançamentos pendentes para conciliar.", "danger", "Nada a Conciliar");
      } else{
        this.$router.push({
          name: "bank-conciliation",
          params: {
            IsUnconciliated: true,
            ...(bankAccount != null ? { BankAccountCode: bankAccount.Code } : {})
          }
        });
      }
    },
    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.validateFieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddBankAccount", this.infoField)
              .then(() => {
                this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");
                this.ListBankAccount();
                this.$bvModal.hide("mFormField");
              })
              .catch(error => {
                this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateBankAccount", this.infoField)
              .then(() => {
                this.$makeToast("O Campo foi atualizado com sucesso.", "success", "Campo atualizado");
                this.ListBankAccount();
                this.$bvModal.hide("mFormField");
              })
              .catch(error => {
                this.$makeToast("Erro ao atualizar campo, tente novamente.", "danger", "Erro ao atualizar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetBankAccount() {
      if (this.idField != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetBankAccount", { id: this.idField })
          .then(response => {
            this.infoField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListBankAccount() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Bank.Code)) this.countFilter++;
      if (hasValue(this.filter.AccountType.Code)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Bank.Code": this.filter.Bank.Code,
        "Object.AccountType.Code": this.filter.AccountType.Code,
        "Object.IsExcluded": this.filter.IsExcluded
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListBankAccount", { params: data })
        .then(response => {
          this.listBankAccounts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ItemTableColor(value) {
      if (value != 0) {
        return value < 0 ? { color: "red" } : { color: "#0ac37f" };
      } else {
        return {};
      }
    },
    ConfirmDelete(obj) {
      console.log(obj)
      const agencyPlusDig = obj.BankAgency + (obj.BankAgencyDigit > 0 ? '-' + obj.BankAgencyDigit : '');
      const accountPlusDig = obj.BankAccount + (obj.BankAccountDigit > 0 ? '-' + obj.BankAccountDigit : '');
      const presentation = `Banco ${obj.Bank.Name}, Agência ${agencyPlusDig}, ${obj.AccountType.Name} ${accountPlusDig}`;
      this.$makeMsgBox("Você tem certeza que deseja remover " + presentation + " ?", "Confirmar", this.DeleteBankAccount, id);
    },
    DeleteBankAccount(id) {
      this.$store
        .dispatch("DeleteBankAccount", { id: id })
        .then(() => {
          this.$makeToast("O Campo foi removido com sucesso.", "success", "Campo removido");
          this.ListBankAccount();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao remover Campo", error);
        });
    },
    GetBanksAndAccountTypes() {
      const promiseBanks = this.$store.dispatch("GetBanks", {});
      const promiseAccountTypes = this.$store.dispatch("ListAccountType", {});

      Promise.all([
        promiseBanks.catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os bancos. Tente novamente.",
            "danger",
            "Erro ao listar os Bancos",
            error
          );
        }),
        promiseAccountTypes.catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os tipos de contas. Tente novamente.",
            "danger",
            "Erro ao listar os Tipos de Contas",
            error
          );
        })
      ])
        .then(([responseBanks, responseAccountTypes]) => {
          this.bankAccounts = responseBanks;
          this.accountTypes = responseAccountTypes;

          this.bankAccounts.sort((a, b) => a.Code.localeCompare(b.Code));
          this.accountTypes.sort((a, b) => a.Name.localeCompare(b.Name));
        });
    },
    GetSummary() {
      this.loadingSummary = true;
      this.$store
        .dispatch("GetBankAccountSummary", new Date())
        .then((response) => {
          this.summaryData = response;
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar o resumo", error);
        })
        .finally(() => (this.loadingSummary = false));
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/BankAccount/BankAccount.js